import React from "react";
import AdfoxAdaptive from "./AdFoxAdaptive";

function getOptions(isTop) {
    if (isTop) {
        return [
            {
                ownerId: 407082,
                containerId: "adfox_17383046303398666",
                params: {
                    p1: "dfxjw",
                    p2: "frfe",
                },
            },
            ["desktop", "tablet"],
            {
                tabletWidth: 830,
                phoneWidth: 480,
                isAutoReloads: true,
            },
        ];
    } else {
        return [
            {
                ownerId: 407082,
                containerId: "adfox_1738304600797666",
                params: {
                    p1: "dfxjt",
                    p2: "huoa",
                },
            },
            ["tablet", "phone"],
            {
                tabletWidth: 830,
                phoneWidth: 480,
                isAutoReloads: true,
            },
        ];
    }
}

export function AdfoxInvisible({ isTop }) {
    const options = getOptions(isTop);
    if (!options) {
        return null;
    }
    return <AdfoxAdaptive options={options} cls={false} />;
}
